// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8902) return "static/chunks/8902-c2cf88ccfb60ecb9.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "fe1d22ea65429129" + ".js";
};